<template>
  <div
    class="register-box show-flex-box-r show-flex-center"
    v-if="showFindPassword"
    @click.self="closeFindPasswordPop()"
  >
    <div class="register-total show-flex-box-r show-flex-center">
      <div class="register-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="closeFindPasswordPop()"></em>
        <dl class="register-content show-flex-box-c">
          <dt class="select-register-way show-flex-box-r">
            <span :class="activeClass == 1? 'active': '' " @click="selectFindPasswordWay(1)">手机号找回</span>
            <span :class="activeClass == 2? 'active': '' " @click="selectFindPasswordWay(2)">邮箱找回</span>
          </dt>

          <dd class="register-input-number show-flex-box-c">
            <h3 class="show-flex-box-c">
              <strong>{{phoneOrEmail}}</strong>
              <span class="show-flex-box-r">
                <input type="text" :placeholder="firstplaceholder" v-model="findPasswordForm.account" />
                <em v-if="countDownStatus" style="color:rgba(193,190,190,1);">{{remainCount}} s</em>
                <em v-else @click="verifyCodeCountDown()">获取验证码</em>
              </span>
              <em>
                <em v-if="validAccountRes">{{validAccountResTitle}}</em>
              </em>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>验证码</strong>
              <span class="show-flex-box-r">
                <input type="text" placeholder="请输入验证码" v-model="findPasswordForm.verify_code" />
              </span>
              <em>
                <em v-if="validVerifyCodeRes">{{validVerifyCodeResTitle}}</em>
              </em>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>设置密码</strong>
              <span class="show-flex-box-r">
                <input type="password" placeholder="请输入密码" v-model="findPasswordForm.password" />
              </span>
              <em>
                <em v-if="validPasswordRes">{{validPasswordResTitle}}</em>
              </em>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>确认密码</strong>
              <span class="show-flex-box-r">
                <input type="password" placeholder="请确认密码" v-model="findPasswordForm.rePassword" />
              </span>
              <em>
                <em v-if="validRepasswordRes">{{validRepasswordResTitle}}</em>
              </em>
            </h3>
            <div class="show-flex-box-r" @click="clickToFindPassword()">
              <span>完成</span>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import regex from "@/filter/regex";
  import { CountDown } from "@/../static/js/CountDown";
  // import {LoginUser} from "@/model/login_user.js";

  export default {
    name: "findPassword",
    data() {
      return {
        activeClass: 1,
        phoneOrEmail: "手机号",
        firstplaceholder: "请输入手机号",
        showFindPassword: false,
        findPasswordLoading: false,

        validAccountRes: false,
        validPasswordRes: false,
        validRepasswordRes: false,
        validVerifyCodeRes: false,

        validAccountResTitle: "",
        validPasswordResTitle: "",
        validRepasswordResTitle: "",
        validVerifyCodeResTitle: "",

        countDown: false,
        countDownStatus: false,
        remainCount: 60,
        findPasswordForm: {
          way: "phone",
          account: "",
          password: "",
          rePassword: "",
          verify_code: ""
        }
      };
    },
    components: {},
    mounted() {
      this.listenKeyEvent();
      // this.initCountDown();
    },
    methods: {
      closeFindPasswordPop: function() {
        this.showFindPassword = !this.showFindPassword;
      },
      clickToFindPassword: function() {
        if (this.validRegisterParams()) {
          if (!this.findPasswordLoading) {
            this.findPasswordLoading = true;
            var params = {
              account: this.findPasswordForm.account,
              way: this.findPasswordForm.way,
              verify_code: this.findPasswordForm.verify_code,
              password: this.findPasswordForm.password
            };

            this.$client
              .findPassword(params)
              .then(res => {
                console.log("修改成功");
                console.log(res);
                if (res.code == 200) {
                  this.$message({
                    showClose: true,
                    message: "密码已修改",
                    type: "success"
                  });
                  this.resetForm();
                  this.findPasswordLoading = false;
                  this.showFindPassword = false;
                }
              })
              .catch(err => {
                console.log("修改失败");
                console.log(err);
                if (err.data && err.data.message) {
                  this.$message({
                    showClose: true,
                    message: err.data.message,
                    type: "error"
                  });
                }
                this.findPasswordLoading = false;
              });
          }
        }
      },
      validRegisterParams: function() {
        var status = true;

        if (regex.isEmpty(this.findPasswordForm.account)) {
          this.validAccountRes = true;
          this.validAccountResTitle =
            this.activeClass == 1 ? "请输入您的手机号" : "请输入您的邮箱";
          status = false;
        } else {
          this.validAccountRes = false;
          this.validAccountResTitle = "";
        }

        if (regex.isEmpty(this.findPasswordForm.verify_code)) {
          this.validVerifyCodeRes = true;
          this.validVerifyCodeResTitle = "请输入您收到的验证码";
          status = false;
        } else {
          this.validPasswordRes = false;
          this.validVerifyCodeResTitle = "";
        }

        if (regex.isEmpty(this.findPasswordForm.password)) {
          this.validPasswordRes = true;
          this.validPasswordResTitle = "请输入您的密码";
          status = false;
        } else {
          if (!regex.isUserPassword(this.findPasswordForm.password)) {
            this.validPasswordRes = true;
            this.validPasswordResTitle = "您输入的密码格式不正确";
            status = false;
          } else {
            this.validPasswordRes = false;
            this.validPasswordResTitle = "";
          }
        }

        if (regex.isEmpty(this.findPasswordForm.rePassword)) {
          this.validRepasswordRes = true;
          this.validRepasswordResTitle = "请再次输入您的密码";
          status = false;
        } else {
          this.validRepasswordRes = false;
          this.validRepasswordResTitle = "";
          if (
            this.findPasswordForm.password != this.findPasswordForm.rePassword &&
            !regex.isEmpty(this.findPasswordForm.rePassword)
          ) {
            this.validRepasswordRes = true;
            this.validRepasswordResTitle = "您两次输入的密码不一致";
            status = false;
          } else {
            this.validRepasswordRes = false;
            this.validRepasswordResTitle = "";
          }
        }

        return status;
      },
      listenKeyEvent() {
        let _this = this;
        $(document).keyup(function(event) {
          if (event.keyCode == 13) {
            if (_this.showFindPassword && !_this.findPasswordLoading) {
              _this.clickToFindPassword();
            }
          }
        });
      },
      initCountDown: function() {
        var _this = this;

        this.counter = new CountDown(60, function(cnt) {
          if (0 === cnt) {
            _this.clearCounterWithCount();
          } else {
            _this.remainCount = cnt;
          }
        });
      },
      clearCounterWithCount: function() {
        this.counter && this.counter.cancel();
        this.countDownStatus = false;
      },
      verifyCodeCountDown: function(count) {
        var allowStatus = this.checkCanVerify();

        if (!this.counter) {
          this.initCountDown();
        }

        if (allowStatus) {
          this.sendMessage();
        }
      },
      checkCanVerify: function() {
        var status = true;
        if (this.activeClass == 1) {
          if (regex.isEmpty(this.findPasswordForm.account)) {
            this.validAccountRes = true;
            this.validAccountResTitle = "请输入您的手机号";
            return false;
          } else {
            this.validAccountRes = false;
            this.validAccountResTitle = "";
          }

          if (regex.isPhoneNumber(this.findPasswordForm.account)) {
            this.validAccountRes = false;
            this.validAccountResTitle = "";
            return true;
          } else {
            this.validAccountRes = true;
            this.validAccountResTitle = "您输入的手机号格式不正确";
            return false;
          }
        } else if (this.activeClass == 2) {
          if (regex.isEmpty(this.findPasswordForm.account)) {
            this.validAccountRes = true;
            this.validAccountResTitle = "请输入您的邮箱";
            return false;
          } else {
            this.validAccountRes = false;
            this.validAccountResTitle = "";
          }

          if (regex.isEmail(this.findPasswordForm.account)) {
            this.validAccountRes = false;
            this.validAccountResTitle = "";
            return true;
          } else {
            this.validAccountRes = true;
            this.validAccountResTitle = "您输入的邮箱格式不正确";
            return false;
          }
        }
      },
      // 发送验证码
      sendMessage: function() {
        var _this = this;
        var params = {
          account: this.findPasswordForm.account,
          way: this.activeClass == 1 ? "phone" : "email",
          type: "find_pwd"
        };

        this.$client
          .sendVerifyCode(params)
          .then(res => {
            console.log("验证码发送成功");
            console.log(res);
            _this.countDownStatus = true;
            _this.counter.start();
          })
          .catch(err => {
            _this.clearCounterWithCount();
            console.log("验证码发送失败");
            console.log(err);
            if (err.data && err.data.message) {
              _this.$message({
                showClose: true,
                message: err.data.message,
                type: "error"
              });
            }
          });
      },
      selectFindPasswordWay: function(index) {
        this.activeClass = index;
        this.validAccountRes = false;
        this.validPasswordRes = false;
        this.validRepasswordRes = false;
        this.validVerifyCodeRes = false;

        this.validAccountResTitle = "";
        this.validPasswordResTitle = "";
        this.validRepasswordResTitle = "";
        this.validVerifyCodeResTitle = "";
  
        this.remainCount = 60;
        this.clearCounterWithCount();

        if (index == 1) {
          this.phoneOrEmail = "手机号";
          this.firstplaceholder = "请输入手机号";
          this.findPasswordForm.way = "phone";
        } else {
          this.phoneOrEmail = "邮箱";
          this.firstplaceholder = "请输入邮箱";
          this.findPasswordForm.way = "email";
        }
      },
      resetForm: function() {
        // this.findPasswordForm.way = "";
        this.findPasswordForm.account = "";
        this.findPasswordForm.password = "";
        this.findPasswordForm.rePassword = "";
        this.findPasswordForm.verify_code = "";
      },
      resetFormValid: function() {
        this.validAccountRes = false;
        this.validPasswordRes = false;
        this.validRepasswordRes = false;
        this.validVerifyCodeRes = false;

        this.validAccountResTitle = "";
        this.validPasswordResTitle = "";
        this.validRepasswordResTitle = "";
        this.validVerifyCodeResTitle = "";
      }
    },
    watch: {
      activeClass: function() {
        this.resetForm();
      },
      showFindPassword: function() {
        this.resetForm();
        this.resetFormValid();
      }
    }
  };

</script>
<style lang="less" scoped>
  .register-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  .register-total {
    position: absolute;
    width: 553px;
    height: 714px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    z-index: 1000;
    .register-all {
      width: 513px;
      height: 674px;
      align-items: flex-end;
      flex-shrink: 0;
      > em {
        width: 22px;
        height: 22px;
        background: url("../../assets/login/close_arrow_icon.png") no-repeat
          center center;
        background-size: 22px 22px;
        cursor: pointer;
        flex-shrink: 0;
      }
      .register-content {
        padding: 8px 60px 32px 60px;
        .select-register-way {
          width: 100%;
          height: 50px;
          align-items: center;
          > span {
            width: 197px;
            height: 50px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(48, 41, 41, 1);
            line-height: 50px;
            text-align: center;
            border-bottom: 1px #eeeeee solid;
            cursor: pointer;
          }
          > span:nth-child(1) {
            border-right: 1px #eeeeee solid;
          }
          .active {
            color: rgba(230, 0, 18, 1);
            border-top: 2px #e60012 solid;
            border-left: 1px #eeeeee solid;
            // border-right: 1px #EEEEEE solid;
            border-bottom: none;
          }
          > em {
            height: 20px;
            > em {
              height: 17px;
              margin-left: 15px;
              font-size: 12px;
              font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
              font-weight: 500;
              color: rgba(230, 0, 18, 1);
              line-height: 17px;
              margin-bottom: 3px;
            }
          }
        }
        .register-input-number {
          width: 100%;
          margin: 45px 0px 32px 0px;
          > h3 {
            width: 100%;
            margin-bottom: 20px;
            > strong {
              height: 21px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(48, 41, 41, 1);
              line-height: 21px;
              margin-bottom: 6px;
            }
            > span {
              flex-flow: 1;
              padding: 0px 3.8%;
              height: 52px;
              border: 1px solid rgba(221, 221, 221, 1);
              align-items: center;
              justify-content: space-between;
              > input {
                width: 100%;
                height: 100%;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(48, 41, 41, 1);
                flex-flow: 1;
              }
              > em {
                flex-shrink: 0;
                flex-wrap: nowrap;
                height: 19px;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(230, 0, 18, 1);
                line-height: 19px;
                padding-right: 15px;
                cursor: pointer;
                margin-left: 20px;
              }
            }
            > em {
              height: 20px;
              > em {
                height: 17px;
                margin-left: 15px;
                font-size: 12px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(230, 0, 18, 1);
                line-height: 17px;
                margin-bottom: 3px;
              }
            }
          }
          > div {
            width: 100%;
            height: 52px;
            background: rgba(48, 41, 41, 1);
            > span {
              width: 100%;
              height: 100%;
              text-align: center;
              line-height: 52px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              cursor: pointer;
            }
          }
        }
        .register-footter {
          width: 100%;
          justify-content: center;
          align-items: center;
          .agree-register {
            align-items: center;
            > span {
              width: 17px;
              height: 17px;
              background: url("../../assets/login/noselect_is_agree_icon.png")
                no-repeat center center;
              background-size: 17px 17px;
              cursor: pointer;
            }
            .select-active {
              width: 17px;
              height: 17px;
              background: url("../../assets/login/select_is_agree_icon.png")
                no-repeat center center;
              background-size: 17px 17px;
            }
            > strong {
              margin-left: 5px;
              height: 19px;
              font-size: 13px;
              font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
              font-weight: 500;
              color: rgba(48, 41, 41, 1);
              line-height: 19px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/find_password.vue